import { useState, useEffect } from 'react';
import { SYS_BREAKPOINT_2_XL, } from '@oneaudi/unified-web-common';
export const useDesktopOrMobileView = (screenBreakpoint) => {
    const [isDesktop, setIsDesktop] = useState(false);
    const setDeviceType = () => {
        setIsDesktop(window.matchMedia(`(min-width: ${screenBreakpoint})`).matches);
    };
    useEffect(() => {
        setDeviceType();
        window.addEventListener('resize', setDeviceType);
        return () => {
            window.removeEventListener('resize', setDeviceType);
        };
    }, []);
    return isDesktop ? 'desktop' : 'mobile';
};
export const useViewPortSize = (container) => {
    var _a;
    const screenWidthForSSR = widthFromBreakpoint(SYS_BREAKPOINT_2_XL);
    const [width, setWidth] = useState(isBrowser() ? ((_a = container === null || container === void 0 ? void 0 : container.offsetWidth) !== null && _a !== void 0 ? _a : window.innerWidth) : screenWidthForSSR);
    useEffect(() => {
        if (!isBrowser())
            return undefined;
        const handleResize = () => { var _a; return setWidth((_a = container === null || container === void 0 ? void 0 : container.offsetWidth) !== null && _a !== void 0 ? _a : window.innerWidth); };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [container]);
    return {
        isSmallerThan: (bp) => width < widthFromBreakpoint(bp),
        isBiggerThanOrEqualTo: (bp) => width >= widthFromBreakpoint(bp),
    };
};
const widthFromBreakpoint = (bp) => bp.endsWith('px') ? Number(bp.replace('px', '')) : 1920;
export const isBrowser = () => typeof window !== 'undefined';
export function useResizeObserver(ref, offsetRight) {
    const [metrics, setMetrics] = useState({
        scrollWidth: 0,
        clientWidth: 0,
        scrollLeft: 0,
        hasOverflow: false,
        atRightEnd: false,
        atLeftEnd: true,
    });
    useEffect(() => {
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!el)
            return undefined;
        const update = () => {
            setMetrics({
                scrollWidth: el.scrollWidth,
                clientWidth: el.clientWidth,
                scrollLeft: el.scrollLeft,
                hasOverflow: el.scrollWidth > el.clientWidth,
                atRightEnd: el.scrollLeft + el.clientWidth >= el.scrollWidth - (offsetRight !== null && offsetRight !== void 0 ? offsetRight : 0),
                atLeftEnd: el.scrollLeft === 0,
            });
        };
        update();
        el.addEventListener('scrollend', update, { passive: true });
        const observer = hasResizeObserver() && new ResizeObserver(update);
        if (observer) {
            observer.observe(el);
        }
        return () => {
            el.removeEventListener('scrollend', update);
            if (observer) {
                observer.disconnect();
            }
        };
    }, [ref]);
    return metrics;
}
function hasResizeObserver() {
    return isBrowser() && typeof window.ResizeObserver !== 'undefined';
}
